// extracted by mini-css-extract-plugin
export default {"base":"Links_base__Wtr+f"};